module.exports = __webpack_public_path__ + "assets/img/btn-more-a31b44dc.png";